module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/163.40f15472.png";